/* eslint-disable no-unused-vars */
import cx from 'classnames'
import { SliderThumb } from '@mui/material/Slider'
import useStyles from './styles'

const CustomThumbComponent = (props) => {
  const { children, hideLabel, ...other } = props
  const classes = useStyles()

  return (
    <div className={cx(classes.slider_thumb, 'custom-thumb-component')}>
      <SliderThumb {...other}>
        {children}
        {!hideLabel && (
          <>
            <span className="custom-bar" />
            <span className="custom-bar" />
            <span className="custom-bar" />
          </>
        )}
        {hideLabel && other.ownerState.value}
      </SliderThumb>
    </div>
  )
}

export default CustomThumbComponent
